var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.50182 8.47501L1.61016 5.58334C1.28516 5.25834 0.760156 5.25834 0.435156 5.58334C0.110156 5.90834 0.110156 6.43334 0.435156 6.75834L3.91849 10.2417C4.24349 10.5667 4.76849 10.5667 5.09349 10.2417L13.9102 1.42501C14.2352 1.10001 14.2352 0.575006 13.9102 0.250006C13.5852 -0.0749939 13.0602 -0.0749939 12.7352 0.250006L4.50182 8.47501Z",
    fill: "#03CE91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.d9a7e26d031b624666500df2709ffa33.svg";
export { ForwardRef as ReactComponent };